import styled from "styled-components";

interface IMenuOptionProps {
  disabled?: boolean;
}

export const ContainerSideMenu = styled.div`
  position: fixed;
  z-index: 100;

  width: 20rem;
  height: 100%;

  display: flex;
  align-items: center;
  flex-direction: column;

  background: ${({ theme }) =>
    theme.controlPanel?.secondaryBackgroundControlPanel};

  padding: 0.5rem;

  margin-top: 1rem;

  @media screen and (max-width: 1099px) {
    width: 16rem;
  }
`;
